export const initialLoadState = {
  deliveryEndDateTime: null,
  deliveryStartDateTime: null,
  driver: null,
  fillAll: true,
  location: null,
  poNumber: '',
  trailer: null,
};

export const initialSupplierState = {
  compartments: {},
};

export const initialCompartmentState = {
  additives: [], // House Recipe,
  destination: null,
  loadType: null,
  loadingControl: null, // Custom Recipe
  product: null, // Unload
  products: {}, // House Recipe,
  recipe: null,
  supplier: null, // Custom Recipe & Unload
  volume: '',
};

export const initialProductState = {
  loadingControl: null,
  supplier: null,
};
